import { Control } from 'react-hook-form';
import { UiSettingsModel } from '@casops/store/apis/settingsApi';
import { useTranslation } from 'react-i18next';
import useTimezoneSettings from './useTimezoneOptions';
import useMeasurementUnitOptions from './useMeasurementUnitOptions';
import useLocaleFormatOptions from './useLocaleFormatOptions';
import CasFormDropdown from '@cas/components/inputs/cas-form-dropdown/CasFormDropdown';

interface LocalizationControlsProps {
  control: Control<UiSettingsModel, unknown, UiSettingsModel>;
}

export function LocalizationControls({ control }: LocalizationControlsProps) {
  const { t } = useTranslation();

  // This hook fetches the locale formats from the API and returns them as dropdown items.
  const localeFormats = useLocaleFormatOptions();
  const measurementUnitOptions = useMeasurementUnitOptions();
  const timezoneOptions = useTimezoneSettings();

  return (
    <>
      <CasFormDropdown
        control={control}
        name="localization.dateTimeNumberFormat"
        label={t('Fields.DateTimeNumberFormat')}
        items={localeFormats}
      />
      <CasFormDropdown
        control={control}
        name="localization.units"
        label={t('Fields.MeasurementUnit')}
        items={measurementUnitOptions}
      />
      <CasFormDropdown
        control={control}
        name="localization.timezone"
        label={t('Fields.Timezone')}
        items={timezoneOptions}
      />
    </>
  );
}

export default LocalizationControls;
